import {
  IN_PROGRESS_STAGE_STATUSES,
  type InProgressStageKey,
  type ListingStatusKpi,
} from '../constants/listingRequestLifecycle'
import type { ListingRequestStatusCounts } from '../types/listingRequestTypes'

/**
 * How many of the seller's requests fall in one status group, from the
 * server-side counts — every request, not just the page on screen. An empty
 * `statuses` is the "All" card.
 */
function sumStatuses(statuses: string[], counts: ListingRequestStatusCounts): number {
  return statuses.reduce((sum, status) => sum + (counts.byStatus[status] ?? 0), 0)
}

export function countListingStatusKpi(
  kpi: ListingStatusKpi,
  counts: ListingRequestStatusCounts,
): number {
  if (!kpi.statuses.length) return counts.total
  return sumStatuses(kpi.statuses, counts)
}

/**
 * Requests in Review, Owner Onboarding, Agreement Signing or Final Approval, per
 * stage. The four sum to the Sell Request page's "In progress" card, so the
 * dashboard can never show a different number for the same thing.
 */
export function countInProgressByStage(
  counts: ListingRequestStatusCounts,
): Record<InProgressStageKey, number> {
  return {
    review: sumStatuses(IN_PROGRESS_STAGE_STATUSES.review, counts),
    onboarding: sumStatuses(IN_PROGRESS_STAGE_STATUSES.onboarding, counts),
    signing: sumStatuses(IN_PROGRESS_STAGE_STATUSES.signing, counts),
    finalApproval: sumStatuses(IN_PROGRESS_STAGE_STATUSES.finalApproval, counts),
  }
}
